import React from 'react';
import PropTypes from 'prop-types';
import classNames from '../../../utils/classNames';
import './index.scss';

export default function SegmentedTabs({
    options,
    value,
    onChange,
    ariaLabel,
    className = '',
}) {
    return (
        <div
            className={classNames('segmented-tabs', className)}
            role="tablist"
            aria-label={ariaLabel}
        >
            {options.map((option) => {
                const isActive = option.value === value;
                return (
                    <button
                        key={option.value}
                        type="button"
                        role="tab"
                        aria-selected={isActive}
                        className={classNames(
                            'segmented-tabs__btn',
                            isActive && 'segmented-tabs__btn--active',
                        )}
                        onClick={() => {
                            if (typeof onChange === 'function' && !isActive) {
                                onChange(option.value);
                            }
                        }}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
}

SegmentedTabs.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func,
    ariaLabel: PropTypes.string,
    className: PropTypes.string,
};
